// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  /* .modal-body {
      overflow: auto;
      height: calc(100% - 72px);
      &.ios-overflow {
          overflow: auto;
      }
  } */
}
:host ::ng-deep .alert a {
  color: inherit;
}`, "",{"version":3,"sources":["webpack://./src/app/U2000_sharedmodules/U2000_security/U2000_verifyidentity-modal/U2000_verifyidentity-modal.component.scss"],"names":[],"mappings":"AAQA;EACI;;;;;;KAAA;AADJ;AAUQ;EACI,cAAA;AARZ","sourcesContent":["::ng-deep .u2000-verifyidentity-dialog {\n    //height:95%;\n}\n\n::ng-deep .u2000-verifyidentity-content {\n    //height:98%;\n}\n\n:host {\n    /* .modal-body {\n        overflow: auto;\n        height: calc(100% - 72px);\n        &.ios-overflow {\n            overflow: auto;\n        }\n    } */\n\n    ::ng-deep .alert {\n        a {\n            color: inherit;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
